import React from "react"
import PropTypes from "prop-types"
import { Grid, CmsImage } from "@bw/bits"
import { Teaser, TeaserList } from "@bw/partials"

const ListOfSubpages = ({ numberOfColumns, subpages }) => {
  if (subpages.length === 0) {
    return null
  }

  return (
    <Grid columns={numberOfColumns} gap="large">
      {subpages.map(item => {
        return numberOfColumns > 1 ? (
          <Teaser
            key={item.id}
            title={item.title}
            excerpt={item.teaserExcerpt}
            image={
              item.teaserImage ? (
                <CmsImage
                  src={item.teaserImage}
                  alt={item.teaserImage?.alt || item.title}
                />
              ) : null
            }
            to={item.url}
          />
        ) : (
          <TeaserList
            key={item.id}
            to={item.url}
            title={item.title}
            subtitle={item.teaserExcerpt}
          />
        )
      })}
    </Grid>
  )
}

ListOfSubpages.propTypes = {
  numberOfColumns: PropTypes.number,
  subpages: PropTypes.array,
}

ListOfSubpages.defaultProps = {
  numberOfColumns: 3,
  subpages: [],
}

export { ListOfSubpages }
